import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FontAwesomeIconSize from './FontAwesomeIconSize';
import ClientProvider from './client';
export default createDemo(import.meta.url, FontAwesomeIconSize, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/icons/demos/font-awesome-size/FontAwesomeIconSize.tsx",
    "fileName": "FontAwesomeIconSize.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { loadCSS } from 'fg-loadcss';\nimport { ThemeProvider, createTheme } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport Icon from '@mui/material/Icon';\nimport MdPhone from '@mui/icons-material/Phone';\nimport Chip from '@mui/material/Chip';\n\nconst theme = createTheme({\n  colorSchemes: { light: true, dark: true },\n  components: {\n    MuiIcon: {\n      styleOverrides: {\n        root: {\n          // Match 24px = 3 * 2 + 1.125 * 16\n          boxSizing: 'content-box',\n          padding: 3,\n          fontSize: '1.125rem',\n        },\n      },\n    },\n  },\n});\n\nexport default function FontAwesomeIconSize() {\n  React.useEffect(() => {\n    const href = 'https://use.fontawesome.com/releases/v5.14.0/css/all.css';\n    if (document.querySelector(`link[href=\"${href}\"]`)) {\n      return undefined;\n    }\n\n    const node = loadCSS(\n      href,\n      // Inject before JSS\n      (document.querySelector('#font-awesome-css') ||\n        document.head.firstChild) as HTMLElement,\n    );\n\n    return () => {\n      node.parentNode!.removeChild(node);\n    };\n  }, []);\n\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <ThemeProvider theme={theme}>\n        <Chip icon={<MdPhone />} label=\"Call me\" />\n        <Chip icon={<Icon className=\"fas fa-phone-alt\" />} label=\"Call me\" />\n      </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 52,
        "focusedLines": 4,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { loadCSS } from 'fg-loadcss';\nimport { ThemeProvider, createTheme } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport Icon from '@mui/material/Icon';\nimport MdPhone from '@mui/icons-material/Phone';\nimport Chip from '@mui/material/Chip';\n\nconst theme = createTheme({\n  colorSchemes: { light: true, dark: true },\n  components: {\n    MuiIcon: {\n      styleOverrides: {\n        root: {\n          // Match 24px = 3 * 2 + 1.125 * 16\n          boxSizing: 'content-box',\n          padding: 3,\n          fontSize: '1.125rem',\n        },\n      },\n    },\n  },\n});\n\nexport default function FontAwesomeIconSize() {\n  React.useEffect(() => {\n    const href = 'https://use.fontawesome.com/releases/v5.14.0/css/all.css';\n    if (document.querySelector(`link[href=\"${href}\"]`)) {\n      return undefined;\n    }\n\n    const node = loadCSS(\n      href,\n      // Inject before JSS\n      (document.querySelector('#font-awesome-css') ||\n        document.head.firstChild) as HTMLElement,\n    );\n\n    return () => {\n      node.parentNode!.removeChild(node);\n    };\n  }, []);\n\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <ThemeProvider theme={theme}>\n        <Chip icon={<MdPhone />} label=\"Call me\" />\n        <Chip icon={<Icon className=\"fas fa-phone-alt\" />} label=\"Call me\" />\n      </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 46
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "theme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 47
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Chip"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "icon"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "MdPhone"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Call me",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 48
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Chip"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "icon"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Icon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "className"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fas fa-phone-alt",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Call me",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 49
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 52,
    "focusedLines": 4,
    "collapsible": true,
    "externals": [
      "react",
      "fg-loadcss",
      "@mui/material/styles",
      "@mui/material/Stack",
      "@mui/material/Icon",
      "@mui/icons-material/Phone",
      "@mui/material/Chip"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
